
import * as React from "react";
import { SVGProps } from "react";

const SvgCloseNoBorder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 4l-8 8M4 4l8 8"
    />
  </svg>
);

export default SvgCloseNoBorder;